import { RelationType } from 'ogp/hooks/queryHooks/flexWorkers/useGetFlexWorkerProfile';
import { formatFullName } from 'shared/utils/formatting';
import { ApplicantColumnDefinition } from './applicant-table.types';
import {
  ApplicantDetail,
  ShiftApplicantRowActions,
  ShiftDetailsApplicant,
} from '../../applicant-table.types';
import { isEmploymentTypeMismatch } from '../../../claimants/helpers/is-employment-type-mismatch';
import { defaultCheckedInIndicator } from '../../../shared/types/shift-detail-tables.types';

export const getApplicantTableData = (
  applicationDetails: ApplicantDetail[],
  shiftDetails: ShiftDetailsApplicant,
  hideEmploymentTypeFields = false
): ApplicantColumnDefinition<ShiftApplicantRowActions>[] => {
  return applicationDetails.map((applicationDetail) => {
    const employmentTypeMismatch = isEmploymentTypeMismatch(
      shiftDetails,
      applicationDetail.employmentType
    );
    return {
      flexWorkerImage: {
        firstName: applicationDetail.firstName,
        lastName: applicationDetail.lastName,
        imageUrl: applicationDetail.imageUrl,
        relation: { id: applicationDetail.applicationId, relation: RelationType.SHIFTAPPLICATION },
        id: applicationDetail.workerId,
        hasCandidateLevel: applicationDetail.hasCandidateLevel,
        employmentType: hideEmploymentTypeFields ? undefined : applicationDetail.employmentType,
        lenderCompanyName: applicationDetail.lenderCompanyName,
        includeCheckedInIndicator: defaultCheckedInIndicator,
      },
      flexWorkerFullName: formatFullName({
        firstName: applicationDetail.firstName,
        lastName: applicationDetail.lastName,
      }),
      rating: applicationDetail.ratingPercentage,
      attendanceRate: applicationDetail.attendanceRate,
      workedShifts: applicationDetail.workedTotal ?? 0,
      hourlyRate: {
        hourlyRate:
          applicationDetail.employmentType === 'FREELANCER'
            ? applicationDetail.hourlyRateCents / 100
            : null,
        defaultHourlyRate: shiftDetails.defaultHourlyRate / 100,
        workerEmploymentType: applicationDetail.employmentType,
        hasDivergentRate: applicationDetail.hasDivergentRate,
      },
      hasRequiredCertificates: applicationDetail.hasRequiredCertificates ?? false,
      employmentTypeMismatch,
      appliedShifts: applicationDetail.allApplications.length,
      phone: applicationDetail.phone ?? '',
      actions: {
        application: applicationDetail,
        employmentTypeMismatch,
      },
      experienceInMonths: applicationDetail.experienceInMonths ?? undefined,
      contractHoursData: {
        workedMinutes: applicationDetail.workedMinutes ?? null,
        contractMinutes: applicationDetail.contractMinutes ?? null,
      },
      distanceInKm: applicationDetail.distanceInKm,
    };
  });
};
